import AnimateLoader from "./AnimateLoader";

export default AnimateLoader;
